import styled, { css } from 'styled-components'
// icons
import CalendarIconOrigin from 'src/icons/schedule-review.svg'
// components
import FormControl from '@mui/material/FormControl'
import InputAdornment from '@mui/material/InputAdornment'
// themes
import colors from 'themes/colors'
// utils
import { size } from 'polished'

export const CalendarIcon = styled(CalendarIconOrigin)<any>`
  && {
    cursor: pointer;

    ${size('20px')};

    path {
      fill: ${colors.gray400};
    }
  }
`

export const FieldWrapper = styled(FormControl)<{ $isTable: boolean }>`
  && {
    ${({ $isTable }) =>
      $isTable &&
      css`
        input {
          overflow: hidden;
          text-overflow: ellipsis;
          color: currentColor;
        }
      `}
  }
`

export const StyledInputAdornment = styled(InputAdornment)`
  && {
    gap: 8px;
    z-index: 1;
    height: 100%;

    svg:first-child {
      cursor: pointer;

      ${size('18px')};
    }
  }
`
